function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError('Cannot call a class as a function');
    }
}
function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ('value' in descriptor)
            descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps)
        _defineProperties(Constructor.prototype, protoProps);
    if (staticProps)
        _defineProperties(Constructor, staticProps);
    return Constructor;
}
import { Switch } from './components/components';
var Feedback = function () {
    function Feedback(player) {
        _classCallCheck(this, Feedback);
        this.player = player;
        this.template = player.template;
        this.initPlayerFeedBack();
        this.initDanmakuFeedback();
    }
    _createClass(Feedback, [
        {
            key: 'initPlayerFeedBack',
            value: function initPlayerFeedBack() {
                var _this = this;
                var feedbackData;
                var feedbackItems = this.template.feedbackMask.querySelectorAll('.mfunsPlayer-switch');
                feedbackItems.forEach(function (el, index) {
                    if (!_this['feedbackOption'.concat(index)]) {
                        _this['feedbackOption'.concat(index)] = new Switch(el, false, {
                            on: function on() {
                                _this.template.feedbackDetail.innerText = null;
                                _this.template.fullscreenInputContent.value = null;
                                for (var i = 0; i < feedbackItems.length; i++) {
                                    i !== index && _this['feedbackOption'.concat(i)].off(1);
                                }
                                _this.currentFeedback = index;
                                if (el.children[1].innerHTML !== '其他') {
                                    feedbackData = el.children[1].innerHTML;
                                    _this.template.feedbackDetail.classList.remove('show');
                                    _this.template.feedbackSubmit.classList.remove('disable');
                                } else {
                                    feedbackData = '';
                                    _this.template.feedbackDetail.classList.add('show');
                                    _this.template.feedbackSubmit.classList.add('disable');
                                    _this.template.feedbackDetail.value = '';
                                }
                            },
                            off: function off(optionTrigger) {
                                _this.template.feedbackDetail.innerText = null;
                                _this.template.fullscreenInputContent.value = null;
                                if (_this.template.feedbackDetail.classList.contains('show'))
                                    _this.template.feedbackDetail.classList.remove('show');
                                if (!_this.template.feedbackSubmit.classList.contains('disable') && !optionTrigger)
                                    _this.template.feedbackSubmit.classList.add('disable');
                            }
                        });
                    } else {
                        _this['feedbackOption'.concat(index)].off();
                    }
                });
                this.template.feedbackDetail.addEventListener('click', function () {
                    _this.template.fullscreenInput.classList.add('show');
                    _this.template.fullscreenInput.ontransitionend = function () {
                        _this.template.fullscreenInput.classList.contains('show') && _this.template.fullscreenInputContent.focus();
                    };
                    _this.template.fullscreenInputConfirmBTN.onclick = function () {
                        _this.template.fullscreenInputContent.blur();
                        _this.template.feedbackDetail.innerText = _this.template.fullscreenInputContent.value.trim();
                        feedbackData = _this.template.feedbackDetail.innerText;
                        if (_this.template.fullscreenInputContent.value.trim()) {
                            _this.template.feedbackSubmit.classList.remove('disable');
                        } else {
                            _this.template.feedbackSubmit.classList.add('disable');
                        }
                        _this.template.fullscreenInput.classList.remove('show');
                    };
                });
                this.template.feedbackSubmit.addEventListener('click', function () {
                    if (_this.template.feedbackSubmit.classList.contains('disable'))
                        return;
                    _this.player.events.trigger('feedback', {
                        reporter: _this.player.options.uid || 'unknown',
                        content: feedbackData
                    });
                    _this.clearFeedBack();
                    _this.player.set.hide('feedback');
                });
            }
        },
        {
            key: 'clearFeedBack',
            value: function clearFeedBack() {
                console.log(this.currentFeedback);
                this.currentFeedback >= 0 && this['feedbackOption'.concat(this.currentFeedback)].off();
                this.template.feedbackDetail.innerText = null;
                this.template.fullscreenInputContent.value = null;
                this.template.feedbackSubmit.classList.add('disable');
            }
        },
        {
            key: 'initDanmakuFeedback',
            value: function initDanmakuFeedback() {
                var _this2 = this;
                var danmakuReportData;
                var danmakuReportItems = this.template.danmakuReportMask.querySelectorAll('.mfunsPlayer-switch');
                danmakuReportItems.forEach(function (el, index) {
                    if (!_this2['reportOption'.concat(index)]) {
                        _this2['reportOption'.concat(index)] = new Switch(el, false, {
                            on: function on() {
                                _this2.template.danmakuReportDetail.innerText = null;
                                _this2.template.fullscreenInputContent.value = null;
                                for (var i = 0; i < danmakuReportItems.length; i++) {
                                    i !== index && _this2['reportOption'.concat(i)].off(1);
                                }
                                _this2.currentDanmakuReport = index;
                                if (el.children[1].innerHTML !== '其他') {
                                    danmakuReportData = el.children[1].innerHTML;
                                    _this2.template.danmakuReportDetail.classList.remove('show');
                                    _this2.template.danmakuReportSubmit.classList.remove('disable');
                                } else {
                                    danmakuReportData = '';
                                    _this2.template.danmakuReportDetail.classList.add('show');
                                    _this2.template.danmakuReportSubmit.classList.add('disable');
                                    _this2.template.danmakuReportDetail.value = '';
                                }
                            },
                            off: function off(optionTrigger) {
                                _this2.template.danmakuReportDetail.innerText = null;
                                _this2.template.fullscreenInputContent.value = null;
                                if (_this2.template.danmakuReportDetail.classList.contains('show'))
                                    _this2.template.danmakuReportDetail.classList.remove('show');
                                if (!_this2.template.danmakuReportSubmit.classList.contains('disable') && !optionTrigger)
                                    _this2.template.danmakuReportSubmit.classList.add('disable');
                            }
                        });
                    } else {
                        _this2['reportOption'.concat(index)].off();
                    }
                });
                this.template.danmakuReportDetail.addEventListener('click', function () {
                    _this2.template.fullscreenInput.classList.add('show');
                    _this2.template.fullscreenInput.ontransitionend = function () {
                        _this2.template.fullscreenInput.classList.contains('show') && _this2.template.fullscreenInputContent.focus();
                    };
                    _this2.template.fullscreenInputConfirmBTN.onclick = function () {
                        _this2.template.fullscreenInputContent.blur();
                        _this2.template.danmakuReportDetail.innerText = _this2.template.fullscreenInputContent.value.trim();
                        danmakuReportData = _this2.template.danmakuReportDetail.innerText;
                        if (_this2.template.fullscreenInputContent.value.trim()) {
                            _this2.template.danmakuReportSubmit.classList.remove('disable');
                        } else {
                            _this2.template.danmakuReportSubmit.classList.add('disable');
                        }
                        _this2.template.fullscreenInput.classList.remove('show');
                    };
                });
                this.template.danmakuReportSubmit.addEventListener('click', function () {
                    if (_this2.template.danmakuReportSubmit.classList.contains('disable'))
                        return;
                    var danData = JSON.parse(_this2.template.danmakuReportMask.querySelector('.danmaku-content').dataset.danData);
                    _this2.player.events.trigger('danmaku_report', {
                        reporter: _this2.player.options.uid || 'unknown',
                        danData: danData,
                        reason: danmakuReportData
                    });
                    _this2.clearDanmakuReport();
                    _this2.player.set.hide('danmakuReport');
                    _this2.player.video.paused && _this2.player.play();
                });
            }
        },
        {
            key: 'clearDanmakuReport',
            value: function clearDanmakuReport() {
                console.log(this.currentDanmakuReport);
                this.currentDanmakuReport >= 0 && this['reportOption'.concat(this.currentDanmakuReport)].off();
                this.template.danmakuReportDetail.innerText = null;
                this.template.fullscreenInputContent.value = null;
                this.template.danmakuReportSubmit.classList.add('disable');
            }
        }
    ]);
    return Feedback;
}();
export {
    Feedback as default
};